<template>
  <span
    class="list-item d-flex justify-content-between align-items-center"
    :class="{active, darkTextColor}"
  >
    <span>
      <svg v-if="active" class="check-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
      </svg>
  
      <slot></slot>
    </span>

    <span>
      <slot name="after"></slot>
    </span>
  </span>
</template>

<script>

// dark-text-color

export default {
  props: {
    active: Boolean,
    darkTextColor: Boolean,
  },
}

</script>

<style scoped>

.list-item {
  cursor: pointer;
  padding: 6px 3px;
}

.list-item + .list-item {
  border-top: 1px solid #E3E3E3;
  cursor: pointer;
}

.list-item:first-child {
  border-top: none !important;
}

.list-item:hover {
  background-color: rgb(249,250,251);
}

.active, .check-icon {
  color: #87CB16;
}

.list-item.darkTextColor {
  color: currentColor !important;
}

.active .check-icon {
  opacity: 1;
}

.check-icon {
  opacity: 0;
  transform: translateY(-3px);
}


</style>
